export * from './catalog';
export * from './types';
export {
  LEDGER_PROFILE_VERSION,
  abandonNightRun,
  advanceAfterCounter,
  anteFor,
  availablePledges,
  closeNightRun,
  continueAfterHours,
  currentTable,
  highTableHeadStart,
  dailyPledge,
  fieldNight,
  finishNightTable,
  hallmarkCandidates,
  interestOn,
  isBolted,
  isRotten,
  maxTerm,
  onLoan,
  pledgeDeck,
  recordNightAction,
  rots,
  setFielding,
  setHallmark,
  skipTable,
  startNightRun,
  tableDifficulty,
  withLedger,
} from './run';
export type { NightRunOptions, NightTableResult } from './run';
export {
  buyBackPawn,
  buyBargain,
  buyFixture,
  buyLot,
  buyOffer,
  closeLot,
  gain,
  hireCost,
  hirePawn,
  itemSellValue,
  meltCard,
  meltCost,
  pickFromLot,
  reorderMantel,
  ringBell,
  ringCost,
  sellItem,
  sellPawn,
  applyBenchCurio,
  nextTrayRare,
} from './shop';
export type { BenchTarget, GainTarget } from './shop';
export {
  bidAtAuction,
  chartOmens,
  chooseDetour,
  chooseSpoils,
  confess,
  finishDetour,
  fuseTwins,
  makePuzzle,
  puzzleConfig,
  puzzlePosition,
  solvePuzzle,
  takeDetourOffer,
  stokeFurnace,
} from './detours';
export { FEATURES, ITEM_UNLOCKS, PLEDGE_UNLOCKS, checkUnlocks, isItemUnlocked } from './meta';
export {
  basePrice,
  cardPrice,
  curioSlots,
  debtLimit,
  mantelSlots,
  mantelUsed,
  owns,
  priceAt,
} from './util';

import type { Profile } from '../types';
import { advanceAfterCounter } from './run';
import { leaveCounter } from './shop';

/** Leaves the Counter for the next table or Night. */
export const leaveNightCounter = (p: Profile): Profile => leaveCounter(p, advanceAfterCounter);
